"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_definition_1 = require("./../services/service-definition");
var topic_selector_serialiser_1 = require("./../topics/topic-selector-serialiser");
var fetch_query_result_serialiser_1 = require("./../services/fetch-query/fetch-query-result-serialiser");
var fetch_query_serialiser_1 = require("./../services/fetch-query/fetch-query-serialiser");
exports.SUBSCRIBE = {
    id: 3,
    request: topic_selector_serialiser_1.TopicSelectorSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.UNSUBSCRIBE = {
    id: 4,
    request: topic_selector_serialiser_1.TopicSelectorSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.FETCH_QUERY = {
    id: 117,
    request: fetch_query_serialiser_1.FetchQuerySerialiser,
    response: fetch_query_result_serialiser_1.FetchQueryResultSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topics-services.js
// module id = 542
// module chunks = 1